import {gsap} from "gsap";
import $ from "jquery";

export class Marquee {
  constructor({container, track, itemSelector, speed = -20}) {
    this.$container = $(container);
    this.$track = this.$container.find(track);
    this.itemSelector = itemSelector;
    this.speed = speed; // pixel/sec
    this.currentX = 0;
  }

  init() {
    this.fill();
    this.start();
  }

  fill() {
    const containerWidth = this.$container.outerWidth();
    let contentWidth = 0;

    // Fill enough content to cover the viewport
    const $items = this.$track.children(this.itemSelector);

    $items.each(function () {
      contentWidth += $(this).outerWidth(true);
    });

    // Clone items until we have enough width
    while (contentWidth < containerWidth * 1.5) {
      $items.each((i, el) => {
        const $clone = $(el).clone();
        this.$track.append($clone);
        contentWidth += $clone.outerWidth(true);
      });
    }
  }

  start() {
    gsap.ticker.add(this.tick);
  }

  stop() {
    gsap.ticker.remove(this.tick);
  }

  tick = () => {
    const delta = gsap.ticker.deltaRatio(60);
    this.currentX += (this.speed / 60) * delta;

    gsap.set(this.$track, { x: this.currentX, force3D: true });

    const containerWidth = this.$container.outerWidth();
    const $children = this.$track.children();
    const $first = $children.first();
    const $last = $children.last();

    if (this.speed < 0) {
      // Moving LEFT — recycle first item to the end
      const firstWidth = $first.outerWidth(true);
      const firstRight = $first.position().left + this.currentX + firstWidth;

      if (firstRight <= 0) {
        this.$track.append($first);
        this.currentX += firstWidth;
        gsap.set(this.$track, { x: this.currentX });
      }
    } else {
      // Moving RIGHT — recycle last item to the front
      const lastWidth = $last.outerWidth(true);
      const lastLeft = $last.position().left + this.currentX;

      if (lastLeft >= containerWidth) {
        this.$track.prepend($last);
        this.currentX -= lastWidth;
        gsap.set(this.$track, { x: this.currentX });
      }
    }
  };
}
